export const sideMenuItems = {
    data() {
        return {
            showSideMenu: false,
            menuBaseItems: [
                { title: "My Account", url: "/account" },
                { title: "My Connections", url: "/connections" },
                {
                    title: "Customize Trackers",
                    url: "/customize-trackers",
                    shouldDisplay: () =>
                        ["professional_silver"].includes(this.$root.organization.type) ||
                        (!this.$root.organization.is_customizations_global &&
                            this.$root.permissions.includes("clinical.trackers.view")),
                },
                { title: "", class: "separator" },
            ],
            menuOrganizationGoldItems: [
                {
                    title: "Patients",
                    url: "/patients",
                    shouldDisplay: () => this.$root.permissions.includes("client.details.view"),
                },
                { title: "Staff", url: "/therapists" },
                { title: "", class: "separator" },
                { title: "Schedule", url: "/schedule" },
                {
                    title: "Reports",
                    url: "/reports",
                    shouldDisplay: () =>
                        (["professional_platinum"].includes(this.$root.organization.type) &&
                            this.$root.permissions.includes("reports.view_export")) ||
                        ["professional_gold"].includes(this.$root.organization.type),
                },
            ],
            menuOrganizationPlatinumItems: [
                {
                    title: "Funding Sources",
                    url: "/funding-sources",
                    shouldDisplay: () =>
                        this.$root.permissions.includes("funding_sources.view_edit"),
                },
            ],
            menuSuperUserItems: [],
            menuDevItems: [],
            menuDemoItems: [
                { title: "", classs: "separator" },
                { title: "Analytics", class: "inactive-menu-items" },
                { title: "Library", class: "inactive-menu-items" },
                { title: "Document Templates", class: "inactive-menu-items" },
            ],
            menuFooterItems: [],
            menuClients: [],
            helpCategories: [],
            isSmallDisplay: false,
        };
    },

    created() {
        this.initializeEventListeners();
    },

    mounted() {
        this.checkSmallDisplay();
        this.populateEnvironmentSpecificMenu();
    },

    computed: {
        menuItems() {
            if (this.isSmallDisplay) {
                return [
                    { title: "Client Goals", items: [...this.menuClients] },
                    {
                        title: "Data Tracker",
                        url: "/data-tracker",
                        shouldDisplay: () =>
                            ["professional_silver"].includes(this.$root.organization.type) ||
                            this.$root.permissions.includes("clinical.trackers.view"),
                    },
                    { title: "", class: "separator" },
                    ...this.menuBaseItems,
                    ...this.menuFooterItems,
                ];
            }
            return [...this.menuBaseItems, ...this.menuFooterItems];
        },
    },

    methods: {
        initializeEventListeners() {
            this.$bus.$on("show-sidemenu", () => this.toggleSideMenu());
            this.$bus.$on("populate-sidemenu-schedule", () => this.populateSideMenuSchedule());
            this.$bus.$on("populate-sidemenu-control-center", () =>
                this.populateSideMenuControlCenter()
            );
            this.$bus.$on("populate-sidemenu-clients", payload =>
                this.populateSideMenuClients(payload)
            );
            this.$bus.$on("populate-sidemenu-help", payload => this.populateSideMenuHelp(payload));
            this.$bus.$on("populate-sidemenu-super-user", () => this.populateSideMenuSuperUser());
            this.$bus.$on("populate-sidemenu-gold", () => this.populateSideMenuGold());
            this.$bus.$on("populate-sidemenu-platinum", () => this.populateSideMenuPlatinum());
        },
        toggleSideMenu() {
            this.showSideMenu = !this.showSideMenu;
        },
        checkSmallDisplay() {
            const windowWidth = window ? window.innerWidth : 0;
            if (windowWidth && windowWidth < 590) {
                this.isSmallDisplay = true;
            }
        },
        populateSideMenuControlCenter() {
            this.menuBaseItems = [
                ...this.menuBaseItems,
                { title: "Control Center", url: "/control-center" },
            ];
        },
        populateSideMenuHelp(payload) {
            this.helpCategories = payload;
            this.menuFooterItems.splice(1, 0, { title: "Help Center", url: "/help" });
        },
        populateSideMenuSuperUser() {
            this.menuBaseItems = [...this.menuBaseItems, ...this.menuSuperUserItems];
        },
        populateSideMenuGold() {
            this.menuBaseItems = [...this.menuBaseItems, ...this.menuOrganizationGoldItems];
        },
        populateSideMenuPlatinum() {
            this.menuBaseItems = [
                ...this.menuBaseItems,
                ...this.menuOrganizationGoldItems,
                ...this.menuOrganizationPlatinumItems,
            ];
        },
        populateEnvironmentSpecificMenu() {
            switch (this.$env) {
                case "development":
                    this.populateSideMenuDev();
                    break;
                case "demo":
                    this.populateSideMenuDemo();
                    break;
            }
        },
        populateSideMenuDev() {
            this.menuBaseItems = [...this.menuBaseItems, ...this.menuDevItems];
        },
        populateSideMenuDemo() {
            this.menuBaseItems = [
                ...this.menuBaseItems,
                ...this.menuOrganizationGoldItems,
                ...this.menuDemoItems,
            ];
        },
        populateSideMenuClients(payload) {
            this.clients = payload.forEach(c => {
                this.menuClients.push({
                    title: c.name + ` Overview`,
                    url: `/patients/${c.id}/goals`,
                });
                this.menuClients.push({
                    title: c.name + `'s Goals`,
                    items: c.goals,
                });
            });
        },
    },
};
